import { IApplicantHistoryItem, IApplicantHistoryResponse } from "@/src/types/applicant";
import { IApplyInfoHistoryItem } from "@/src/types/applicationOnline";

const toApplyInfoHistoryItem = (item: IApplicantHistoryItem | IApplicantHistoryResponse, fallbackApplicantId: number): IApplyInfoHistoryItem => ({
  student_id: "student_id" in item && item.student_id != null ? item.student_id : (item.applicant_id ?? fallbackApplicantId),
  text: item.text,
  created_at: item.created_at,
  employee_name: item.employee_name ?? "",
  employee_role: item.employee_role ?? "",
  employee_photo: item.employee_photo ?? null,
});

export const mapApplicantHistoryItems = (
  history: (IApplicantHistoryItem | IApplicantHistoryResponse)[],
  applicantId: number,
): IApplyInfoHistoryItem[] => history.map((item) => toApplyInfoHistoryItem(item, applicantId));
